<template>
  <div class="login-gr-class">
    <div style="height: 100vh">
      <div
        style="
        height: 90vh;
        display: table;
        width: 100%;"
      >
        <div
          style="
            display: table-cell;
            vertical-align: middle;
        "
        >
          <div v-show="!isShowWellcomeModal" class="main-agile" style="">
            <div class=""></div>
            <div class="content-wthree">
              <div class="about-middle">
                <section class="slider">
                  <div class="flexslider">
                    <ul class="slides">
                      <li>
                        <div class="banner-bottom-2">
                          <div class="about-midd-main">
                            <img
                              :src="imgLogo && imgLogo.url"
                              alt=" "
                              class="img-responsive"
                              style="margin: auto"
                            />
                            <div v-if="SITE_NAME_INFO === siteConfigEnum.CONASI_SITE || SITE_NAME_INFO === siteConfigEnum.APOLLO_SITE">
                              <h4 style="color:black;">
                                <b v-if="SITE_NAME_INFO === siteConfigEnum.CONASI_SITE">CONASI HOME</b>
                                <b v-else>A HOME</b>
                              </h4>
                              <p style="color:black;">{{ $t("common.residentialManagementApplication") }} <br> {{ $t("common.management") }}</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="clear"></div>
                </section>
              </div>
              <div class="new-account-form">
                <router-view></router-view>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <!--  -->
          <div v-show="isShowWellcomeModal" class="main-agile">
            <div class="alert-close" @click="onCloseWellcome"></div>
            <div class="content-wthree">
              <div class="about-middle" style="float: none; margin: auto; padding-top: 15px; padding-bottom: 15px;">
                <section class="slider">
                  <div class="flexslider">
                    <ul class="slides">
                      <li>
                        <div class="banner-bottom-2">
                          <div class="about-midd-main">
                            <img
                              :src="imgLogo && imgLogo.url"
                              alt=" "
                              class="img-responsive"
                              style="margin: auto; max-width: 250px;"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="clear"></div>
                </section>
              </div>
              <div class="clear"></div>
            </div>
            <div>
              <div class="wellcome-modal-content">
                {{ $t('common.wellcomeToApp', { 0: getSiteInfo().site_name_info }) }}
              </div>
              <div class="show-wellcome-checkbox">
                <label class="anim">
                  <div style="display: inline-flex;">
                    <span style="color:black; margin-right: 5px">{{
                      $t("common.doNotShowNextLogin")
                    }}</span>
                    <input type="checkbox" class="checkbox" v-model="isHideWellcomeForm" />
                  </div>
                </label>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
      <div
        class="footer-w3l"
        style="
          margin: 0;
          height: 10vh;
          display: table;
          width: 100%;"
      >
        <div
          style="
            display: table-cell;
            vertical-align: middle;"
        >
          <p v-if="SITE_NAME_INFO === siteConfigEnum.CONASI_SITE" class="agileinfo">
            &copy; CONASI HOME | Copyright by
            <a href="http://conasi.vn" target="_blank"> Conasi</a>
          </p>
          <p v-else-if="SITE_NAME_INFO === siteConfigEnum.APOLLO_SITE" class="agileinfo">
            &copy; APOLLO HOME | Copyright by
            <a href="https://apollotech.vn/" target="_blank"> Apollo Technologies</a>
          </p>
          <p v-else class="agileinfo">
            <strong>{{
              $t("common.copyright", { "0": this.copy_right })
            }}</strong>
          </p>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    >
    </lte-core-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'
import config_img from "../../lib/config";
import config from "../../../build/config";
import siteImgConfig from "@/lib/siteImgConfig";
import siteConfigEnum from "@/enum/siteConfigEnum";
export default {
  name: "Login",
  data() {
    return {
      img_url: config_img.imgUrlConfig,
      credentials: {
        username: "",
        password: ""
      },
      siteImgConfig: siteImgConfig,
      imgLogo: null,
      copy_right: "Avatar Solutions",
      siteConfigEnum: siteConfigEnum,
      SITE_NAME_INFO: config.SITE_NAME_INFO,
      isHideWellcomeForm: true,
      isShowWellcomeModal: false
    };
  },
  watch: {
    IS_SHOW_WELLCOME_MODAL: function() {
      this.isShowWellcomeModal = true
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "IS_SHOW_WELLCOME_MODAL"
    ])
  },
  methods: {
    login: function() {
      const credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      };
      this.SET_TOKEN(credentials)
        .then(
          function() {
            this.CHECK_TOKEN().then(
              function() {
                let url = window.location.href.toString();
                let targetUrl = url.replace("/account/login", "/dashboard");
                window.location.href = targetUrl;
              }.bind(this)
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    setLang() {
      let data = this.$i18n.locale === "en" ? "vi" : "en";
      this.SET_LANG(data);
    },
    getSiteInfo: function() {
      let results = null;
      let index = this.siteImgConfig.findIndex(
        x => x.site_name_info_value === config.SITE_NAME_INFO
      );
      if (index !== -1) {
        results = this.siteImgConfig[index];
      }
      return results;
    },
    getLogoData: function(logoName) {
      let results = null;
      let dataList = this.getSiteInfo().imgList;
      let index = dataList.findIndex(x => x.name === logoName);
      if (index !== -1) {
        results = dataList[index];
      }
      return results;
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo();
      link.href = siteInfo.urlIcon;
      document.title = siteInfo.site_name_info;
      this.copy_right = siteInfo.name;
    },
    showModal: function() {
      $("#modal-wellcome").modal("show");
    },
    hideModal: function() {
      $("#modal-wellcome").modal("hide");
    },
    onCloseWellcome: function() {
      let data = {
        value: this.isHideWellcomeForm
      }
      this.UPDATE_IS_SHOW_WELLCOME(data).then(
        function() {
          let url = window.location.href.toString();
          this.GET_GENERAL_USER_SETTINGS().then(
            function(res){
              // let is_show_wellcome = res.data.is_show_wellcome
              let num_projects = res.data.project_count
              if (num_projects > 0){
                let targetUrl = url.replace(
                  "/account/login",
                  "/dashboard"
                );
                window.location.href = targetUrl;
              }
              else{
                let targetUrl = url.replace(
                  "/account/login",
                  "/no-project"
                );
                window.location.href = targetUrl;
              }
            }.bind(this)
          );
        }.bind(this)
      );
      
    },
    ...mapActions([
      "SET_TOKEN",
      "CHECK_TOKEN",
      "ERROR_TOAST",
      "SET_LANG",
      "UPDATE_IS_SHOW_WELLCOME",
      "GET_GENERAL_USER_SETTINGS"
    ])
  },
  components: {
    "lte-core-alert": LTECoreAlert
  },
  mounted() {
    this.imgLogo = this.getLogoData("login-logo");
    this.updateTabTitle();
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/login_style.css";
// @import "../../styles/login-flexslider.css";
.login-logo h3 {
  font-size: 120px;
  margin-bottom: -30px;
  color: brown;
  font-family: fantasy;
}

.login-logo span {
  font-size: 18px;
  color: brown;
  font-family: fantasy;
}

.resize {
  height: auto;
  width: auto;
  max-width: 350px;
  max-height: 350px;
}

.resize-mini {
  height: auto;
  width: auto;
  max-width: 50px;
  max-height: 50px;
}

header {
  background-color: white;
}

.login-gr-class {
  background: #00c6d7;
  background: linear-gradient(
    to right bottom,
    #85c446,
    rgba(133, 196, 70, 0.7),
    rgba(133, 196, 70, 0.31)
  );
  background: url("../../assets/images/default-bg-login.jpg") no-repeat 0px 0px;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  font-family: "Josefin Sans", sans-serif;
}
.show-wellcome-checkbox {
  text-align: right;
  padding: 15px;
}
.wellcome-modal-content {
  padding: 30px 15px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Account/AccountV2.vue